import React from 'react';
import MenuItem from './MenuItem';

const MenuList = ({ menus, onMenuClick, selectedMenu }) => {
  return (
    <div id='menu-list' className="menu-list">
      {menus.map(menu => (
        <MenuItem
          key={menu.id}
          menu={menu}
          isActive={selectedMenu?.id === menu.id}
          onClick={onMenuClick}
        />
      ))}
    </div>
  );
};

export default MenuList;
